module.exports = __webpack_public_path__ + "static/media/f_2.e6a0ba40.jpg";